/**
 * Converts a Date object to its corresponding AM or PM period.
 *
 * @param {Date} date - The Date object to be checked.
 * @returns {string} - Returns "AM" if the hour is before 12 PM, or "PM" if the hour is 12 or later.
 *
 * @example
 * const period = dateToAmPm(new Date('2025-04-08T10:00:00'));
 * console.log(period); // Output: "AM"
 *
 * @example
 * const period = dateToAmPm(new Date('2025-04-08T15:00:00'));
 * console.log(period); // Output: "PM"
 */
export default function dateToAmPm(date) {
  return date.getHours() >= 12 ? 'PM' : 'AM';
}
